export default "__VITE_ASSET__Bb0jd_Fe__"